<template>
  <div class="sequence-box">
    <div v-for="(chain, i) in structure.chains" class="chain" :key="i">
      <div><b>Chain {{ chain.chainname }}</b></div>
      <div class="chain-residues">
        <span v-for="(residue, j) in structure.residues[i]" :class="{'residue':true, 'active':residue.active}" @click="$emit('toggle', [{ object: structure, residue }])" :key="j">{{ residue.resno }}-{{ residue.resname }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sequence',

  data () {
    return {
      residues: []
    }
  },

  props: [ 'structure', 'selection' ],

  methods: {
    debug (s) {
      console.log(JSON.stringify(s))
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.sequence-box {
  background-color: white;
  box-sizing: border-box;
  overflow-x: auto;
  color: $font-grey;
  padding: 10px;
  font-size: 12px;
}

.chain {
  margin-bottom: 10px;
}

.chain-residues {
  white-space: nowrap;
}

.residue {
  cursor: pointer;
  margin: 10px 5px;
  padding: 2px 5px;
}

.residue.active {
  background-color: $theme-color;
  color: white;
  border-radius: 10px;
}

</style>

